import React, { useEffect, useState } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { HowItWorks } from './components/HowItWorks';
import { FeaturedServices } from './components/FeaturedServices';
import { ServicesSection } from './components/ServicesSection';
import { PricingSection } from './components/PricingSection';
import { WhyChooseUs } from './components/WhyChooseUs';
import { CTABanner } from './components/CTABanner';
import { Footer } from './components/Footer';
import { AboutPage } from './pages/AboutPage';
import { BusinessInternetPage } from './pages/BusinessInternetPage';
import { EthernetFiberPage } from './pages/EthernetFiberPage';
import { NetworkSecurityPage } from './pages/NetworkSecurityPage';
import { UCaaSPage } from './pages/UCaaSPage';
import { BusinessPhonePage } from './pages/BusinessPhonePage';
import { VideoMonitoringPage } from './pages/VideoMonitoringPage';
import { AccessControlPage } from './pages/AccessControlPage';
import { EthernetCablingPage } from './pages/EthernetCablingPage';
import { WebsiteDesignPage } from './pages/WebsiteDesignPage';
import { SuppliersPage } from './pages/SuppliersPage';
import { ContactPage } from './pages/ContactPage';
import { MovingSoonPage } from './pages/MovingSoonPage';
import { DomainsHostingPage } from './pages/DomainsHostingPage';
import { CustomerTrust } from './components/CustomerTrust';
import { QuoteModal } from './components/QuoteModal';
import { TruckIcon, ArrowRightIcon } from 'lucide-react';
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
  const navigate = (page: string) => {
    setCurrentPage(page);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-white font-sans text-[#1D2A3A] selection:bg-accent/20 selection:text-primary-dark" data-id="element-0">
      <Navbar onNavigate={navigate} currentPage={currentPage} onOpenQuote={() => setIsQuoteModalOpen(true)} data-id="element-1" />
      <main data-id="element-2">
        {currentPage === 'home' && <>
            <HeroSection onOpenQuote={() => setIsQuoteModalOpen(true)} data-id="element-3" />
            <HowItWorks onOpenQuote={() => setIsQuoteModalOpen(true)} data-id="element-4" />
            <FeaturedServices data-id="element-5" />
            <PricingSection onOpenQuote={() => setIsQuoteModalOpen(true)} data-id="element-6" />

            {/* Are You Moving? CTA Section */}
            <section className="py-16 bg-slate-900 relative overflow-hidden" data-id="element-7">
              <div className="absolute inset-0 bg-grid-pattern opacity-10" data-id="element-8"></div>
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-9">
                <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-3xl p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-10">
                  <div className="flex items-center gap-6" data-id="element-11">
                    <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center shrink-0" data-id="element-12">
                      <TruckIcon className="w-8 h-8 text-white" data-id="element-13" />
                    </div>
                    <div data-id="element-14">
                      <h2 className="text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-15">
                        Are You Moving?
                      </h2>
                      <p className="text-slate-400 text-lg" data-id="element-16">
                        Let us handle your telecom transition seamlessly.
                      </p>
                    </div>
                  </div>
                  <button onClick={() => navigate('moving-soon')} className="bg-primary hover:bg-primary-dark text-white px-8 py-4 rounded-xl font-bold text-lg transition-all shadow-lg shadow-primary/20 flex items-center gap-2 group" data-id="element-17">
                    Start Your Move
                    <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-18" />
                  </button>
                </div>
              </div>
            </section>

            <WhyChooseUs data-id="element-19" />
            <CustomerTrust data-id="element-20" />
            <CTABanner onOpenQuote={() => setIsQuoteModalOpen(true)} data-id="element-21" />
          </>}
        {currentPage === 'about' && <AboutPage onNavigate={navigate} data-id="element-22" />}
        {currentPage === 'domains-hosting' && <DomainsHostingPage onNavigate={navigate} data-id="element-23" />}
        {currentPage === 'business-internet' && <BusinessInternetPage onNavigate={navigate} data-id="element-24" />}
        {currentPage === 'ethernet-fiber' && <EthernetFiberPage onNavigate={navigate} data-id="element-25" />}
        {currentPage === 'network-security' && <NetworkSecurityPage onNavigate={navigate} data-id="element-26" />}
        {currentPage === 'ucaas' && <UCaaSPage onNavigate={navigate} data-id="element-27" />}
        {currentPage === 'business-phone' && <BusinessPhonePage onNavigate={navigate} data-id="element-28" />}
        {currentPage === 'video-monitoring' && <VideoMonitoringPage onNavigate={navigate} data-id="element-29" />}
        {currentPage === 'access-control' && <AccessControlPage onNavigate={navigate} data-id="element-30" />}
        {currentPage === 'ethernet-cabling' && <EthernetCablingPage onNavigate={navigate} data-id="element-31" />}
        {currentPage === 'website-design' && <WebsiteDesignPage onNavigate={navigate} data-id="element-32" />}
        {currentPage === 'suppliers' && <SuppliersPage onNavigate={navigate} data-id="element-33" />}
        {currentPage === 'contact' && <ContactPage onNavigate={navigate} data-id="element-34" />}
        {currentPage === 'moving-soon' && <MovingSoonPage onNavigate={navigate} data-id="element-35" />}
      </main>
      <Footer onNavigate={navigate} data-id="element-36" />
      <QuoteModal isOpen={isQuoteModalOpen} onClose={() => setIsQuoteModalOpen(false)} data-id="element-37" />
    </div>;
}